import * as React from "react";
import { Button } from "azure-devops-ui/Button";
import { FocusWithin, IFocusWithinStatus } from "azure-devops-ui/FocusWithin";

export default class FocusWithinExample extends React.Component {
    public render(): JSX.Element {
        return (
            <div className="flex-column">
                <FocusWithin>
                    {(focusStatus: IFocusWithinStatus) => (
                        <div
                            className="flex-column"
                            style={{
                                border: focusStatus.hasFocus ? "1px solid blue" : "1px solid black"
                            }}
                        >
                            <div style={{ padding: "8px" }}>
                                <Button
                                    text="Button1"
                                    onFocus={focusStatus.onFocus}
                                    onBlur={focusStatus.onBlur}
                                />
                            </div>
                            <div style={{ padding: "8px" }}>
                                <Button
                                    text="Button2"
                                    onFocus={focusStatus.onFocus}
                                    onBlur={focusStatus.onBlur}
                                />
                            </div>
                            <div style={{ padding: "8px" }}>
                                <Button
                                    text="Button3"
                                    onFocus={focusStatus.onFocus}
                                    onBlur={focusStatus.onBlur}
                                />
                            </div>
                        </div>
                    )}
                </FocusWithin>
                <div style={{ padding: "8px" }}>
                    <Button text="Button4" />
                </div>
            </div>
        );
    }
}
